import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/Users/kei/repos/opera-lang/src/components/Layout.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Note = makeShortcode("Note");
const Part = makeShortcode("Part");
const Ex = makeShortcode("Ex");
const Tr = makeShortcode("Tr");
const LyricSeparator = makeShortcode("LyricSeparator");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`ミカエラのアリア`}</h1>
    <div style={{
      padding: 16,
      margin: 8,
      border: '1px solid orange'
    }}>
  こちらのコンテンツは新しいサイトに移行しています。以下のリンクから新サイトをご覧ください。
  <div style={{
        margin: 16,
        textAlign: "center",
        overflowWrap: "break-word"
      }}>
    <a href="https://capriccioso.info/opera/carmen/je-dis-que-rien">https://capriccioso.info/opera/carmen/je-dis-que-rien</a>
  </div>
    </div>
    <h4>{`Je dis que rien ne m'épouvante`}</h4>
    <p>{`密輸団のアジトにたったひとりでやってきたミカエラが歌うアリア。`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#youtube"
        }}>{`Youtube の動画`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#translation"
        }}>{`対訳と語義解説`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#sheet"
        }}>{`楽譜`}</a></li>
    </ul>
    <h2 name="youtube">Youtube の動画</h2>
    <h4>{`Anne-Catherine Gillet - Georges Bizet - Carmen - Je dis que rien ne m'épouvante.flv`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/V56qEPp8f7Q?start=28" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h4>{`Carmen Vienna State Opera 2010 Anna Netrebko`}</h4>
    <iframe width="100%" height="315" src="https://www.youtube.com/embed/EwvDzT6vfO0?start=66" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
    <h2 name="translation">対訳と語義解説</h2>
    <Note mdxType="Note">単語をクリック（タップ）すると解説が表示されます。</Note>
    <Part mdxType="Part">Micaëla</Part>
    <p>
  <Ex m="私は" mdxType="Ex">Je</Ex> <Ex m="言う" o="dire" mdxType="Ex">dis</Ex> <Ex m="〜ということ（英語のthat） direの目的語「〜と言う」" mdxType="Ex">que</Ex> <Ex m="何も〜ない" mdxType="Ex">rien ne</Ex> <Ex m="私を" mdxType="Ex">m'</Ex><Ex m="おびえさせる" o="épouvanter" mdxType="Ex">épouvante</Ex>,
    </p>
    <Tr mdxType="Tr">何も怖くなんかないわ</Tr>
    <p>
  Je dis, <Ex m="ああ、なんということだ（悲嘆、苦悩などを表す間投詞）" mdxType="Ex">hélas</Ex> ! que je <Ex m="自分の行動に責任を持つ" o="répondre" mdxType="Ex">réponds de moi</Ex>;
    </p>
    <Tr mdxType="Tr">ああ！ 大丈夫だってば</Tr>
    <p>
  <Ex m="しかし" mdxType="Ex">Mais</Ex> j'<Ex m="avoir beau + 動詞「〜しても無駄である」" mdxType="Ex">ai beau</Ex> <Ex m="faire + 定冠詞 + 形容詞「〜を装う」" mdxType="Ex">faire</Ex> la <Ex m="勇ましい" mdxType="Ex">vaillante</Ex>,
    </p>
    <Tr mdxType="Tr">でも、勇気があるふりをしてもだめ</Tr>
    <p>
  Au <Ex m="底" mdxType="Ex">fond</Ex> du <Ex m="心臓、心" mdxType="Ex">cœur</Ex>, je <Ex m="死ぬ" o="mourir" mdxType="Ex">meurs</Ex> d'<Ex m="恐怖" mdxType="Ex">effroi</Ex> !
    </p>
    <Tr mdxType="Tr">本当は怖くて死にそう</Tr>
    <p>
  <Ex m="ひとりきりの" mdxType="Ex">Seule</Ex> en <Ex m="この" mdxType="Ex">ce</Ex> <Ex m="場所" mdxType="Ex">lieu</Ex> <Ex m="野生の、未開の" mdxType="Ex">sauvage</Ex>,
    </p>
    <Tr mdxType="Tr">人里離れた場所にたったひとり</Tr>
    <p>
  <Ex m="まったく（seuleの強調）" mdxType="Ex">Toute</Ex> seule j'<Ex m="持つ" o="avoir" mdxType="Ex">ai</Ex> <Ex m="恐怖" mdxType="Ex">peur</Ex>, mais j'<Ex m="avoir tort de + 動詞 「〜するのは間違っている」" mdxType="Ex">ai tort d'</Ex>avoir peur;
    </p>
    <Tr mdxType="Tr">たったひとりで怖いけど、怖がってはいけないわ</Tr>
    <p>
  <Ex m="あなた（ここではSeigneur「主、神」を指す）" mdxType="Ex">Vous</Ex> <Ex m="私に" mdxType="Ex">me</Ex> <Ex m="与える（単純未来）" o="donner" mdxType="Ex">donnerez</Ex> <Ex m="勇気" mdxType="Ex">du courage</Ex>,
    </p>
    <Tr mdxType="Tr">勇気をお与えください</Tr>
    <p>
  Vous <Ex m="私を" mdxType="Ex">me</Ex> <Ex m="保護する（単純未来）" o="protéger" mdxType="Ex">protégerez</Ex>, <Ex m="主、神" mdxType="Ex">Seigneur</Ex> !
    </p>
    <Tr mdxType="Tr">私をお守りください、神様！</Tr>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>
  Je <Ex m="aller + 動詞 （近接未来）" o="aller" mdxType="Ex">vais</Ex> <Ex m="見る" mdxType="Ex">voir</Ex> <Ex m="すぐ近くから" mdxType="Ex">de près</Ex> <Ex m="この" mdxType="Ex">cette</Ex> <Ex m="女" mdxType="Ex">femme</Ex>
    </p>
    <Tr mdxType="Tr">すぐ近くであの女を見てやるわ</Tr>
    <p>
  <Ex m="deを含む関係代名詞。les artifices de cette femme と考えるとわかりやすい（この場合は英語のwhoseに相当する）" mdxType="Ex">Dont</Ex> <Ex m="策略、詐術" mdxType="Ex">les artifices</Ex> <Ex m="のろわれた" mdxType="Ex">maudits</Ex>
    </p>
    <Tr mdxType="Tr">呪われた手練手管で</Tr>
    <p>
  <Ex m="finir par + 動詞「ついには〜する」（複合過去）（主語はles artifices）" o="finir" mdxType="Ex">Ont fini par</Ex> <Ex m="faire A de B 「BをAにする」" mdxType="Ex">faire</Ex> <Ex m="恥知らず" mdxType="Ex">un infâme</Ex>
    </p>
    <Tr mdxType="Tr">恥知らずにしてしまった</Tr>
    <p>
  De <Ex m="彼（関係代名詞queの先行詞）" mdxType="Ex">celui</Ex> que j'<Ex m="愛する（半過去）" mdxType="Ex">aimais</Ex> <Ex m="かつては" mdxType="Ex">jadis</Ex> !
    </p>
    <Tr mdxType="Tr">私がかつて愛したあの人を！</Tr>
    <p>
  <Ex m="彼女は" mdxType="Ex">Elle</Ex> <Ex m="〜である（英語のbe動詞）" o="être" mdxType="Ex">est</Ex> <Ex m="危険な" mdxType="Ex">dangereuse</Ex>... elle est <Ex m="美しい" mdxType="Ex">belle</Ex> !
    </p>
    <Tr mdxType="Tr">危険な女…、美しい女！</Tr>
    <p>
  Mais je <Ex m="ne ... pas で否定文を作る" mdxType="Ex">ne</Ex> <Ex m="望む" o="vouloir" mdxType="Ex">veux</Ex> <Ex m="ne ... pas で否定文を作る" mdxType="Ex">pas</Ex> <Ex m="持つ" mdxType="Ex">avoir</Ex> <Ex m="恐怖" mdxType="Ex">peur</Ex> !
    </p>
    <Tr mdxType="Tr">でも、怖がったりしたくない！</Tr>
    <p>
  Non, non, je ne veux pas avoir peur !
    </p>
    <Tr mdxType="Tr">だめよ、怖がったりしないわ！</Tr>
    <p>
  Je <Ex m="話す（単純未来）" o="parler" mdxType="Ex">parlerai</Ex> <Ex m="大きな声で、はっきりと" mdxType="Ex">haut</Ex> <Ex m="〜の前で" mdxType="Ex">devant</Ex> <Ex m="彼女" mdxType="Ex">elle</Ex>... Ah ! 
    </p>
    <Tr mdxType="Tr">面と向かってはっきり言ってやるわ… ああ！</Tr>
    <p>
  Seigneur, vous me protégerez, Seigneur, vous me protégerez ! Ah !
    </p>
    <Tr mdxType="Tr">神様、私をお守りください、神様、私をお守りください！ ああ！</Tr>
    <LyricSeparator mdxType="LyricSeparator" />
    <p>
  Je dis que rien ne m'épouvante,
    </p>
    <Tr mdxType="Tr">何も怖くなんかないわ</Tr>
    <p>
  Je dis, hélas ! que je réponds de moi;
    </p>
    <Tr mdxType="Tr">ああ！ 大丈夫だってば</Tr>
    <p>
  Mais j'ai beau faire la vaillante,
    </p>
    <Tr mdxType="Tr">でも、勇気があるふりをしてもだめ</Tr>
    <p>
  Au fond du cœur, je meurs d'effroi !
    </p>
    <Tr mdxType="Tr">本当は怖くて死にそう</Tr>
    <p>
  Seule en ce lieu sauvage,
    </p>
    <Tr mdxType="Tr">人里離れた場所にたったひとり</Tr>
    <p>
  Toute seule j'ai peur, mais j'ai tort d'avoir peur;
    </p>
    <Tr mdxType="Tr">たったひとりで怖いけど、怖がってはいけないわ</Tr>
    <p>
  Vous me donnerez du courage,
    </p>
    <Tr mdxType="Tr">勇気をお与えください</Tr>
    <p>
  Vous me protégerez, Seigneur !
    </p>
    <Tr mdxType="Tr">私をお守りください、神様！</Tr>
    <p>
  <Ex m="保護する（命令法）" o="protéger" mdxType="Ex">Protégez</Ex>-<Ex m="私を" mdxType="Ex">moi</Ex> ! Ô Seigneur ! <Ex m="与える（命令法）" o="donner" mdxType="Ex">donnez</Ex>-moi du courage !
    </p>
    <Tr mdxType="Tr">私をお守りください！ おお、神様！ 勇気をお与えください！</Tr>
    <p>
  Protégez-moi ! Ô Seigneur ! protégez-moi ! Seigneur !
    </p>
    <Tr mdxType="Tr">私をお守りください！ おお、神様！ お守りください！ 神様！</Tr>
    <h2 name="sheet">楽譜</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "800px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/12edec80d9739110656a4ba89a07d0a2/8698d/carmen-je-dis-que-rien.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "190.5%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAmCAYAAADEO7urAAAACXBIWXMAABcSAAAXEgFnn9JSAAAD4UlEQVRIx63W5Y4kMQwE4H7/51rSMjMzM1NOn6Vq7eh0v25HyoScuFwVJ921//h9f3+39/f39vHx0d7e3qrffX19tevr6/b4+NheX19rUs2A8cvLSz/2/PxcfbV54+fn5+3k5KT20O9MjIyMtKWlpba8vNy2t7fb5uZmm56ebqurq21+fr5tbGy0xcXFNjY21qampqrNfnd3t83MzFRZX18vRx2Y+UEUz09PTwN9kaiNfX5+9qi12Sh+HYOJiYl2eHhYyPb399vBwUE7OjoqZAsLC21lZaX6W1tbhXptba3aOzs7bXZ2tuy00dHxdHFxURze3Ny0u7u76p+dnbXT09PaSB2uhMmhecU8B+agLVFsdHl5WeiQqxiDniNzV1dXheD+/r7d3t5Wn3NjDw8PNV4b4mF8fLy88g66tvBHR0dLlL29vQpVeGyFiwZUWUNINgOihGQ/XrWhhEQURIL2p1iJIGMliokgnJubK4TQOEI4ghCKCOa4KOwgxR0ezdm0EzdO8KBWiHB8fNwLRBAcQRtRYqPtDJrvMwUSAzYVgoU829AYkYzZgEMhcqLgzRo0lShCnpycrA0sAB3JwhYmROaFR22hQmQOLfpCRg3eu38lPq/JZYZQqfXN+QGT46LuRSE/ZKSXGbxBkAwgFoRsHGJzookw1oiqECZTeBCSFBQmbmygbxEOHSNiGMOlmg177VI5mWJDJFtICE6EqZgXpmKcDedKhLPeXn2m8IJkIQld27WkTyBCqIWpmBNq5p1N9A1cXzz4cWKcdyWXq5ByfWU8GZYs6zMl+epizZGQrzwLkzBQGiNa0MlvaK0tDnnIDUM55OImmWLcUclcDjTekgDOIZ77TIHAIh6QS0n9XAhJu6RmzqQ5VMSuv75kAi/eiqGhoQoLBWphBpkURYHwjAkXFXl3/sqUPIkRJ7XxtHO95V1JGbi+hoeH+yyANmI4SjxDEtRsHBv2auIQRXSFkCccIFlYQscprn6Kg9fwF0EiZtrFoT+LctrzXiQdGbrzkK7NYa4xDokSB3VshCykXJRCdgYRn7cjIeWGJoiCAtRYY+1ApuSNQD7Sc23lGwZaaKD8+e6gAFL9AVEghMIRUBPDkYBAmNCwybGRTZDnKEHYi5I8xRtlc6PgymbEIooxiNhDlWcCav36WLJhNsn1lb50YpxMMJeMyf2ICsV8//UlxFycoOd7JdeZop1vG0IJNd83qNCub5uIko9HgzyH9DzmSgSD2C8i5ZuxLoeIkuucpxCeY2E8X2URL9kkItF4UwCp2yZva8RIO19XEEDy8y1hhzubsM3F27Vf/hWHv1n+AJD5Jj/OtYkrAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "楽譜",
            "title": "楽譜",
            "src": "/static/12edec80d9739110656a4ba89a07d0a2/5a190/carmen-je-dis-que-rien.png",
            "srcSet": ["/static/12edec80d9739110656a4ba89a07d0a2/772e8/carmen-je-dis-que-rien.png 200w", "/static/12edec80d9739110656a4ba89a07d0a2/e17e5/carmen-je-dis-que-rien.png 400w", "/static/12edec80d9739110656a4ba89a07d0a2/5a190/carmen-je-dis-que-rien.png 800w", "/static/12edec80d9739110656a4ba89a07d0a2/c1b63/carmen-je-dis-que-rien.png 1200w", "/static/12edec80d9739110656a4ba89a07d0a2/8698d/carmen-je-dis-que-rien.png 1239w"],
            "sizes": "(max-width: 800px) 100vw, 800px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      